export const SMALL_GROUP_ROLES = [
    { label: 'Superintendent', value: 'Superintendent' },
    { label: 'Administrator', value: 'Administrator' },
    { label: 'Principal', value: 'Principal' },
    { label: 'Teacher', value: 'Teacher' },
    { label: 'Homeschool Parent', value: 'Homeschool Parent' },
    { label: 'Parent', value: 'Parent' },
    { label: 'Student', value: 'Student' },
    { label: 'Other', value: 'Other' }
];
